/**
 * Small read-only badge showing a user's Odoo department-sync state.
 * Only two states are rendered:
 *   synced     — has >=1 department, no open conflict
 *   not_synced — no department assigned at all
 * Any other value (including the retired 'conflict' state) returns null.
 */
const MAP = {
  synced: { cls: 'ok', label: 'Odoo synced' },
  not_synced: { cls: 'muted', label: 'Not synced' },
};

export default function OdooSyncBadge({ status }) {
  const cfg = MAP[status];
  if (!cfg) return null;
  const title =
    status === 'synced'
      ? 'Department is in sync with Odoo (or manually assigned with no Odoo divergence).'
      : 'No department assigned — not yet matched to an Odoo employee.';
  return (
    <span className={`ut-sync ut-sync--${cfg.cls}`} title={title}>
      {cfg.label}
    </span>
  );
}
